export const getYoutubeInfo = (state, code) => state.ext.youtube[code];
